import { CV_TEMPLATES } from "@/lib/cvTemplates";

/**
 * Horizontal pill picker for CV templates. Uses controlled state.
 */
export default function CvTemplatePicker({ value, onChange, className = "" }) {
  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`} data-testid="cv-template-picker">
      {CV_TEMPLATES.map((tpl) => {
        const active = value === tpl.id;
        return (
          <button
            key={tpl.id}
            type="button"
            onClick={() => onChange(tpl.id)}
            data-testid={`cv-template-${tpl.id}`}
            title={tpl.desc}
            className={`group inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-semibold transition-all ${
              active
                ? "border-zinc-900 bg-zinc-900 text-white shadow-sm"
                : "border-zinc-300 bg-white text-zinc-700 hover:border-zinc-500 hover:bg-zinc-50"
            }`}
          >
            <span aria-hidden>{tpl.emoji}</span>
            <span>{tpl.name}</span>
            <span
              className="w-2.5 h-2.5 rounded-full ring-2 ring-white"
              style={{ background: tpl.vars.accent }}
            />
          </button>
        );
      })}
    </div>
  );
}
